import React from "react";
import { ExternalLink } from "@pepdirect/ui/ExternalLink";
import st from "components/Tracking/tracking.module.scss";

export const renderTrackingNumber = (
  trackingNumber: string,
  trackingUrl?: string
) => {
  if (trackingUrl) {
    return (
      <ExternalLink className={st.trackingLink} href={trackingUrl}>
        {trackingNumber}
      </ExternalLink>
    );
  } else {
    return <div>{trackingNumber}</div>;
  }
};
